import { ErrorAlert } from './Alerts';
import './static/css/contact.css';
import React, { useRef, useState } from 'react';

const Contact = () => {
     const [lenMessage, UpdateLenMessage] = useState(0);
     const [error, ShowErrorMessage] = useState();

     const nameRef = useRef();
     const emailRef = useRef();
     const messageRef = useRef();

     const UpdateMessage = (event) => {
          UpdateLenMessage(event.target.value.length);
     };
     
     const SendMessage = (event) => {
          event.preventDefault();

          var name = nameRef.current.value.trim();
          var email = emailRef.current.value.trim();
          var message = messageRef.current.value.trim();

          var validForm = ValidateForm(name, email, message);
     }

     function ValidateForm(name, email, message) {
          var validName = name != '' && name.length <= 65;
          var validEmail = email != '' && email.length <= 45;
          var validMessage = message != '' && message.length <= 200;

          var errorMessage;

          if (validName && validEmail && validMessage) {
               return true;
          } else if (!validName) {
               errorMessage = "O nome é obrigatório e não pode ultrapassar o limite de 65 caracteres!";
          } else if (!validEmail) {
               errorMessage = "O e-mail é obrigatório e não pode ultrapassar o limite de 45 caracteres!";
          }
          else {
               errorMessage = "A mensagem é obrigatória e não pode ultrapassar o limite de 200 caracteres!";
          }

          ShowErrorMessage(errorMessage);
          return false;
     }

     return (
          <div>
               <ErrorAlert error={error} />

               <div class="contact container col-xl-10 col-xxl-8 pb-5 px-5">
                    <div class="align-items-center g-lg-5 row">
                         <div class="col-lg-7">
                              <h1 class="display-4 fw-bold lh-1 mb-3 text-body-emphasis title">
                                   Entre em contato conosco!
                              </h1>
                              <p class="col-lg-10 lead">
                                   Entre em contato conosco pelos canais abaixo ou, se desejar fazer uma visita, estamos localizados na <a class="text-decoration-none" href="https://www.google.com/maps/place/Infocerta+Informatica/@-30.0304631,-51.2306058,15z/data=!4m2!3m1!1s0x0:0xa68f2ea1395ca6aa?sa=X&ved=1t:2428&ictx=111" target="_blank">Rua dos Andradas, 1091 - Centro Hist&oacute;rico de Porto Alegre/RS</a>.
                              </p>
                              <a class="d-block lead text-decoration-none" href="mailto:comercial@infocerta.com.br" target="_blank">
                                   <i class="bi bi-envelope-fill" /> | comercial@infocerta.com.br
                              </a>
                              <a class="d-block lead mt-3 text-decoration-none" href="tel:555130246464" target="_blank">
                                   <i class="bi bi-telephone-fill" /> | +55 (51) 3024-6464
                              </a>
                         </div>
                         <div class="col-md-10 col-lg-5 mt-4 mt-lg-0 mx-auto">
                              <form class="bg-body-tertiary border p-4 p-md-5 rounded-3" onSubmit={SendMessage}>
                                   <div class="form-floating mb-3">
                                        <input class="border-2 border-end-0 border-light-subtle border-start-0 border-top-0 form-control rounded-0" id="input-name" maxLenght="65" placeholder="Nome" ref={nameRef} type="text" />
                                        <label for="input-name">
                                             Nome
                                        </label>
                                   </div>
                                   <div class="form-floating mb-3">
                                        <input class="border-3 border-end-0 border-light-subtle border-start-0 border-top-0 form-control rounded-0" id="input-email" maxLenght="45" placeholder="E-mail" ref={emailRef} required type="email" />
                                        <label for="input-email">
                                             E-mail
                                        </label>
                                   </div>
                                   <div class="form-floating mb-3">
                                        <textarea class="border-3 border-end-0 border-light-subtle border-start-0 border-top-0 form-control rounded-0" id="input-message" maxLenght="200" onChange={UpdateMessage} placeholder="Mensagem" ref={messageRef} required />
                                        <label for="input-mensagem">
                                             Deixe sua mensagem aqui
                                        </label>
                                   </div>
                                   <p class="text-body-secondary text-end">
                                        {lenMessage}/200
                                   </p>
                                   <button class="border-0 btn btn-lg btn-primary px-4 py-2 rounded-pill w-100" type="submit">
                                        Enviar mensagem
                                   </button>
                              </form>
                         </div>
                    </div>
               </div>
          </div>
     );
}

export default Contact;